import { z } from 'zod';
/**
 * Contracts for the email blacklist (suppress spam senders).
 *
 * Single source of truth shared by the admin API routes and the admin-web
 * `admin-module-blacklist`. A blacklisted email's inbound mail is still stored
 * but never processed or surfaced (see the ingestion gate in
 * `MessageStorePg.insertInbound`).
 */
/** One blacklist list-view row. `reason`/`blockedByName` are nullable. */
export const BlacklistEntryDTO = z.object({
    email: z.string(),
    reason: z.string().nullable(),
    blockedByName: z.string().nullable(),
    createdAt: z.string().datetime(),
});
/** GET /api/blacklist response. */
export const BlacklistListResponse = z.object({
    items: z.array(BlacklistEntryDTO),
});
/** POST /api/blacklist body: add an email to the blacklist. */
export const AddToBlacklistRequest = z.object({
    email: z.string().trim().email(),
    reason: z.string().trim().max(500).optional(),
});
/** POST /api/conversations/:id/blacklist body. */
export const BlacklistConversationRequest = z.object({
    reason: z.string().trim().max(500).optional(),
});
/**
 * POST /api/conversations/:id/blacklist response. `email` is the sender that
 * was blocked (null when the contact had no email — a graceful no-op);
 * `blocked` is the number of the contact's conversations newly hidden.
 */
export const BlacklistConversationResponse = z.object({
    email: z.string().nullable(),
    blocked: z.number().int().nonnegative(),
});
//# sourceMappingURL=blacklist.js.map